import React, { FC, ReactElement } from 'react';
import {
  FlexGrid,
  FlexGridColumn,
  ModalFooter,
  Button,
} from '@clearcover/atlas';
import { useFormikContext } from 'formik';

import { isPresent } from 'Shared/utils';
import styles from './FormModalFooter.module.css';

export type FormModalFooterProps = {
  close: () => void;
  showStatus?: boolean;
  checkDirty?: boolean;
  confirmationModal?: ReactElement;
  identifier: string;
  /** Label for the primary submit button. Defaults to 'Continue'. */
  submitText?: string;
};

export const FormModalFooter: FC<FormModalFooterProps> = ({
  close,
  showStatus = true,
  checkDirty = true,
  confirmationModal,
  identifier,
  submitText = 'Continue',
}) => {
  const { isValid, isSubmitting, status, handleSubmit, dirty } =
    useFormikContext<unknown>();

  return (
    <ModalFooter className={styles.footer}>
      <FlexGrid>
        <FlexGridColumn mobile={8} mobileOffset={2} className={styles.content}>
          <Button
            disabled={isSubmitting}
            data-testid={`${identifier}-modal-cancel`}
            variant="secondary"
            onClick={close}
          >
            Cancel
          </Button>
          {showStatus && isPresent(status) && (
            <div className={styles.error}>{status}</div>
          )}
          {confirmationModal ? (
            confirmationModal
          ) : (
            <Button
              data-testid={`${identifier}-modal-save`}
              variant="primary"
              type="button"
              isSubmitting={isSubmitting}
              onClick={() => handleSubmit()}
              disabled={!isValid || (checkDirty && !dirty)}
            >
              {submitText}
            </Button>
          )}
        </FlexGridColumn>
      </FlexGrid>
    </ModalFooter>
  );
};

FormModalFooter.displayName = 'FormModalFooter';
